import "./style.css"
import "ress"
import { createRoot } from "react-dom/client"
import { datadogLogs } from "@datadog/browser-logs"
import { initM2mComponents } from "m2m-components/initM2mComponents"
import {
    datadogRum,
    type RumEvent,
    type RumEventDomainContext
} from "@datadog/browser-rum"
import { CapacitorUpdater } from "@capgo/capacitor-updater"
import { shouldSuppressLog } from "./utils/datadogLogFilter"
import { App } from "./App"

CapacitorUpdater.notifyAppReady()

const NODE_ENV = process.env.NODE_ENV ?? "development"

// アップロードエンドポイントの正規表現パターン
const uploadEndpointRegex =
    /\/(v2|v3)\/mypage\/cleanings\/[^/]+\/items\/[^/]+\/upload$/

datadogLogs.init({
    service: `m2m-cleaning-cleaner-front-${NODE_ENV}`,
    env: NODE_ENV,
    clientToken: "pub6469dd5321da04c06377d60137804daa",
    site: "datadoghq.com",
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ["error"],
    sessionSampleRate: 100,
    version: process.env.DATADOG_RELEASE_VERSION,
    beforeSend: log => {
        if (shouldSuppressLog(log.message)) {
            return false
        }
        return true
    }
})

datadogRum.init({
    applicationId: "e2f206b0-e3ac-4aee-acb4-48e4ff0e74f8",
    clientToken: "pub3bda25a4c3862bbfad2c6568ebb4a6be",
    site: "datadoghq.com",
    service: "m2m-cleaning-cleaner-front",
    env: process.env.RUNTIME_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackAnonymousUser: false,
    defaultPrivacyLevel: "mask-user-input",
    beforeSend: (event: RumEvent, context: RumEventDomainContext) => {
        if (event.type === "resource" && event.resource.type === "fetch") {
            const url = event.resource.url

            if (uploadEndpointRegex.test(url)) {
                // 1. カスタム属性を追加
                if (event.context) {
                    event.context.is_target_upload = true
                }
            }
        }
        return true // イベントをDatadogに送信するためにtrueを返す
    }
})

datadogRum.startSessionReplayRecording()

if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register("/service-worker.js")
            .then(registration => {
                // eslint-disable-next-line no-console
                console.log("SW registered: ", registration)
            })
            .catch(registrationError => {
                // eslint-disable-next-line no-console
                console.log("SW registration failed: ", registrationError)
            })
    })
}

initM2mComponents({
    env: process.env.NODE_ENV === "production" ? "production" : "development"
})

const element = document.getElementById("root")
if (element) {
    const root = createRoot(element)
    root.render(<App />)
}
